<!--
 * @Author: dumin
 * @Date: 2021-09-24 18:12:57
 * @LastEditTime: 2021-10-11 16:39:47
 * @Description: PC 端首页头部
-->

<template>
  <div class="base-header-comp app-flex-mid">
    <img src="../../../assets/logo.png" class="logo" />
    <div class="opera-wrap app-flex-mid">
      <div :class="['opera-item', menuParentId == item.id ? 'checked' : '']" v-for="item in menuList" :key="item.id" @click="chooseMenu(item)" @mouseenter="item.children ? (show = true) : ''" @mouseleave="item.children ? (show = false) : ''">
        {{ item.name }}
        <template v-if="item.children">
          <base-transition :show.sync="show">
            <ul :class="['item-list']" @click.stop="">
              <li v-for="obj in item.children" :key="obj.id" :class="['child', obj.id == menuChildId ? 'checked' : '']" @click.stop="chooseChild(item, obj)">{{ obj.name }}</li>
            </ul>
          </base-transition>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import BaseTransition from './BaseTransition.vue'

export default {
  name: 'BaseHeader',
  props: {},
  components: {
    BaseTransition
  },
  data() {
    return {
      // 一级菜单的 id
      idx: null,
      // 二级菜单的 id
      childId: null,
      // 控制显示隐藏的
      show: false
    }
  },
  created() {
    this.chooseMenu(this.menuList[0])
  },
  computed: {
    ...mapState(['menuList', 'menuParent', 'menuChild']),
    menuParentId() {
      return this.menuParent.id
    },
    menuChildId() {
      return this.menuChild ? this.menuChild.id : null
    }
  },
  methods: {
    ...mapActions(['navigateTo']),
    chooseMenu(data) {
      this.idx = data.id
      this.childId = null
      this.navigateTo({ $router: this.$router, parent: data, child: this.childId })
    },

    // 有子项的选择的子项
    chooseChild(data, child) {
      this.idx = data.id
      this.childId = child.id
      this.navigateTo({ $router: this.$router, parent: data, child })
    }
  }
}
</script>

<style lang="scss" scoped>
$header-height: 70px;
.base-header-comp {
  width: 100%;
  height: $header-height;
  padding: 0px 260px;
  justify-content: space-between;
  background-color: #e8f4ff;
  .logo {
    width: auto;
    height: 42px;
    user-select: none;
  }
  .opera-wrap {
    height: inherit;
    .opera-item {
      position: relative;
      height: inherit;
      max-width: 160px;
      line-height: $header-height;
      font-size: 16px;
      font-weight: 400;
      color: #272629;
      font-family: PingFangSC-Regular, PingFang SC;
      cursor: pointer;
      transition: all 0.3s;
      user-select: none;
      text-align: center;
      &:not(:last-child) {
        margin-right: 78px;
      }
      &.checked {
        color: #eb543c;
        box-shadow: 0 -6px 0 #eb543c inset;
        font-weight: 600;
      }
      .item-list {
        position: absolute;
        top: 70px;
        left: -70%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 150px;
        padding: 15px 0px;
        background-color: #e8f4ff;
        font-weight: normal;
        .child {
          color: #747a80;
          line-height: 40px;
          &.checked {
            font-weight: bold;
            color: #eb543c;
          }
        }
      }
    }
  }
}
</style>
